import { useUserSession } from '@solinkcorp/authentication';
import { CallhomeApi } from 'clients';
import { useCurrentFeature } from 'src/hooks/useEventFeature';
import useSWR from 'swr';
import { AI_FEATURE } from 'vd-constants';

export function useScheduledActivity(scheduledActivityId?: string) {
  const { accessToken } = useUserSession();

  const feature = useCurrentFeature();

  const scheduledActivity = useSWR(
    feature === AI_FEATURE && scheduledActivityId
      ? ['event', 'recurring-activities', scheduledActivityId]
      : null,
    async ([, , activityId]) => {
      try {
        return await CallhomeApi(accessToken).getRecurringActivityById(activityId);
      } catch (error) {
        console.error('Error fetching scheduled spot checks', error);
      }
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  return scheduledActivity;
}
